import { render, staticRenderFns } from "./plusPage.vue?vue&type=template&id=715a7aa6&scoped=true&"
import script from "./plusPage.vue?vue&type=script&lang=js&"
export * from "./plusPage.vue?vue&type=script&lang=js&"
import style0 from "./plusPage.vue?vue&type=style&index=0&id=715a7aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a7aa6",
  null
  
)

component.options.__file = "plusPage.vue"
export default component.exports